import request from '@/util/request'

// 人员职能列表（不分页）
export const getFunctionList = (data) => {
  return request({
    url: `/api/register/function/list`,
    method: 'GET',
    data
  })
}
